import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledCheckmarkIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 80 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 40,
			cy: 40,
			r: 30,
			fill: "#00AF71",
			stroke: "#00AF71",
			strokeWidth: 7.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.4443 40.0002L35.5554 51.1113L55.5554 31.1113",
			stroke: "white",
			strokeWidth: 7.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgFilledCheckmarkIcon);
const Memo = memo(ForwardRef);
export default Memo;
